import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const MetricWeightReport = React.lazy(() => import('../components/MetricWeightReport'));
function MetricWeightReportView() {
  return (
    <Suspense fallback={<CircularProgress />}>
      <MetricWeightReport />
    </Suspense>
  );
}

export default MetricWeightReportView;
